export default __webpack_public_path__ + "static/media/korma.f508a6d2.jpg";